module.exports = __webpack_public_path__ + "static/media/KinderSachenBörseFlyerA4.0111ba5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/KinderSachenBörseFlyerA4.png
// module id = 116
// module chunks = 0